import * as React from 'react';

const HeaderHeightContext = React.createContext<number | undefined>(undefined);

export default HeaderHeightContext;
